
import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AppHome.css";
import '../Admin/Admin.css';
import Header from "../Home/Header";
import { useNavigate } from 'react-router-dom';
import DialogBox from "../Home/DialogBox";


export default function NewMemberHome() {
  const navigate = useNavigate();

       useEffect(() => {
                const role = sessionStorage.getItem("userRole");
                if (!role) navigate("/");
              }, [navigate]);

  return (
    <div className="dashboard">

      <Header />

      <div className="welcome-container">


        <div className="button-container">
          <button className="big-btn" onClick={() => navigate("/assis/attendance_KB")}>
            👥 Mark Attendance [Kesbawe]
          </button>

          <button className="big-btn blue" onClick={() => navigate("/assis/attendance_WB")}>
             👥 Mark Attendance [Werahare]
          </button>


        </div>
      </div>
    </div>
  );
}
